// 设置展开栏底部按钮

import React, { useEffect, useRef, useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { connect } from "dva";
import "./index.less";
import {
  ChatMessage,
  ChatMessageType,
  Employee,
  FileChatMessage,
  JoySpaceDocumentMessage,
  Session,
  TextChatMessageExt
} from "@/types/chat";
import {
  getReplyMessageDesc,
  isSameClient,
  isShowAlias,
  isCrossPlatformGroupSession,
  isOuterContacts,
  parseMessageToUserBySingle,
  getMessageSendType,
  isOrgNoticeImageTextCardMessage,
  getOrgNoticeMultiMessageData,
  getFileDownloadBzOptions
} from "@/utils/chat/message";
import log from "@/utils/logger";
import { MessageSendType } from "@/types/chat/enum";
import {
  downLoadFile,
  formatAtUser,
  getFileUrl,
  getMessageFileName,
  useLastMyMessage,
  usePrevious,
  getPreviewCanEdit
} from "@/utils/chat/index";
import { Modal, Popover, message as toast } from "antd";
import { FocusSDK, isFocusEnv } from "@/utils";
import ImService from "@/server/ImService";
import {
  getChatMessageNode,
  getHeadPortrait,
  getShowTime,
  TimeTransform,
  getTextMessageContent,
  getVideoModal,
  getPreviewImageModal,
  openShareCommonCard,
  openShareUserCard,
  viewUploadFile,
  downloadReplyFile,
  handleAddFileDownloadRecord,
  checkFileIsExpired
} from "@/components/chat/utils/commonMessageModal";
import { changeEgovUrl, crossAppSwitch, getFileOperateAuthority } from "@/utils/tools";
import bus from "@/utils/bus";
import debounce from "lodash/debounce";
import { useHistory } from "react-router-dom";
import ComGroupAlias from "@/baseComponents/ComGroupAlias";
import DeeplinkEvent from "@/components/DeeplinkHandler/DeeplinkEvent";
import { genThirdAppUrl } from "@/components/ThirdApp";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import { getAppVersion } from "@/utils/getVersion";
import IconFont from "@/components/icon";
import { canJoyspacePreview, openJoyspacePreview } from "@/components/Joyspace/util";
import { getWpsPreviewCode } from "@/api/chat";
import { addXclient } from "@/utils/addToken";
import Text from "@/components/chat/message/Text";
import ChatContext from "@/components/chat/context";

const logger = log.getLogger("comp:ReplyMessage");

interface ReplyMessageProps {
  message: ChatMessage;
  sendType: MessageSendType;
  currentEmployee: Employee;
  selectedSession: Session;
  openNoticeDetails: (data: { isvisibles: boolean; notificationId: any }) => void;
  openSolitaireDetails: Function;
  updateSessionMessageMid: Function;
}

type IProps = Readonly<ReplyMessageProps>;
// let count = 0;
let flag = false;
let isClickModal = true;
function ReplyMessage({
  message,
  sendType,
  currentEmployee,
  selectedSession,
  openNoticeDetails,
  openSolitaireDetails,
  updateSessionMessageMid
}: IProps) {
  const { currentFileControl } = React.useContext(ChatContext);
  const replyMsg =
    message.replyMsgs && message.replyMsgs.length > 0
      ? (message.replyMsgs[0] as ChatMessage)
      : undefined;
  const { t } = useTranslation("chat");
  const { authInfo, appRuntimeEnv } = React.useContext<GlobalContextConfig>(GlobalContext);
  const [visible, setVisible] = useState(false); // 文本气泡
  const [popoverContent, setPopoverContent] = useState<any>(""); // 文本内容
  const [isModalVisible, setIsModalVisible] = useState(false); // 转发
  const [timeSection, setTimeSection] = useState(""); // 转发日期
  const [modalMessages, setModalMessages] = useState([] as any[]); // 转发消息体
  const isLastFromMe = useLastMyMessage(message, currentEmployee);
  const {
    im,
    fileService: { imAppKey },
    joyspaceWpsTarget
  } = appRuntimeEnv;
  const dRef = useRef<HTMLDivElement>(null);

  const canWpsPreview = useMemo(() => {
    const isOutApp = selectedSession.isGroup
      ? isCrossPlatformGroupSession(selectedSession)
      : isOuterContacts(selectedSession, currentEmployee);
    const isDisplay = !isOutApp && crossAppSwitch("joyspace");
    return isDisplay && !selectedSession.isSecret && joyspaceWpsTarget === "private";
  }, [selectedSession, currentEmployee]);

  const handleHide = () => {
    setVisible(false);
  };

  useEffect(() => {
    if (isLastFromMe) {
      if (dRef?.current) {
        // const box = dRef.current.closest("div[class~=message-box-container-scroll]");
        // if (box) {
        //   box.scrollTop = box.scrollHeight;
        // }
      }
    }
  }, [isLastFromMe]);

  useEffect(() => {
    const scrollBox = document.getElementById("message-box-container-scroll");
    scrollBox?.addEventListener("scroll", handleHide);
    return () => {
      scrollBox?.removeEventListener("scroll", handleHide);
    };
  }, []);

  function getReplyTextContent() {
    const msg = replyMsg as TextChatMessageExt;
    const result = getTextMessageContent(
      selectedSession,
      {
        ...msg,
        content: isShowAlias(selectedSession) && msg.atContent ? msg.atContent : msg.content
      },
      currentEmployee
    ).trim();
    setPopoverContent(result);
    setVisible(true);
  }

  function onVisibleChange(visible: boolean) {
    if (replyMsg?.type !== ChatMessageType.TEXT || replyMsg?.revoke) {
      return;
    }
    setVisible(visible);
  }

  const getReplyImageContent = async () => {
    const isExpired = checkFileIsExpired({
      expiredAppKey: imAppKey,
      message: replyMsg as any,
      updateSessionMessageMid,
      expiredTime: im.fileExpiredTime,
      type: "image"
    });
    if (isExpired) return;
    getPreviewImageModal({ message: replyMsg });
  };

  const getReplyVideoContent = async () => {
    const isExpired = checkFileIsExpired({
      expiredAppKey: imAppKey,
      message: replyMsg as any,
      updateSessionMessageMid,
      expiredTime: im.fileExpiredTime,
      type: "video"
    });
    if (isExpired) return;
    if (isClickModal) {
      isClickModal = false;
      getVideoModal(replyMsg);
    }
    setTimeout(() => {
      isClickModal = true;
    }, 2000);
  };

  const downLocalFile = async (fileMessage: FileChatMessage, updateSessionMessageMid: Function) => {
    const isExpired = checkFileIsExpired({
      expiredAppKey: imAppKey,
      message: fileMessage,
      updateSessionMessageMid,
      expiredTime: im.fileExpiredTime
    });
    if (isExpired) return;
    if (!isFocusEnv()) {
      // 网页版下载之后查看
      const name = getMessageFileName(fileMessage);
      const url = await addXclient(
        getFileUrl(fileMessage.url, getFileDownloadBzOptions(selectedSession))
      );
      downLoadFile(name, url, "", {
        onFinish: () => {
          handleAddFileDownloadRecord(fileMessage, currentEmployee, 0, selectedSession);
        }
      });
      return;
    }
    const downLocalPath = fileMessage.downLocalPath;
    if (!downLocalPath) {
      downloadReplyFile({ fileMessage, t, currentEmployee, selectedSession });
    }
    if (isFocusEnv() && downLocalPath) {
      FocusSDK.checkLocalPathExist(downLocalPath, (exists: boolean) => {
        if (exists) {
          FocusSDK.openItem(downLocalPath);
        } else {
          downloadReplyFile({ fileMessage, t, currentEmployee, selectedSession });
        }
      });
    }
  };

  const handleDownload = (fileMessage: FileChatMessage) => {
    if (
      sendType === MessageSendType.OWNER ||
      sendType === MessageSendType.SELF ||
      sendType === MessageSendType.OTHER
    ) {
      // console.log(sendType, 'sendType');
      if (
        !isSameClient(fileMessage) ||
        (isFocusEnv() && !fileMessage.downLocalPath && !fileMessage.upLocalPath)
      ) {
        console.log("down");
        const isExpired = checkFileIsExpired({
          expiredAppKey: imAppKey,
          message: fileMessage,
          updateSessionMessageMid,
          expiredTime: im.fileExpiredTime
        });
        if (isExpired) return;
        if (!FocusSDK.isPrivateNet() && fileMessage.type === ChatMessageType.EGOV_FILE) {
          toast.error(t("egov-file-notice"));
          return;
        }
        downLocalFile(fileMessage, updateSessionMessageMid);
      } else {
        console.log("view");
        viewUploadFile({
          message: fileMessage,
          t,
          updateSessionMessageMid,
          expiredTime: im.fileExpiredTime,
          folderPath: "",
          currentEmployee,
          selectedSession
        });
      }
    } else {
      downLocalFile(fileMessage, updateSessionMessageMid);
    }
  };

  const getReplyFileContent = async () => {
    const fileMessage = replyMsg as FileChatMessage;
    if (canWpsPreview) {
      const isEgovFile =
        message.type === ChatMessageType.EGOV_FILE || message.kind === ChatMessageType.EGOV_FILE;
      const isWpsFile = canJoyspacePreview(fileMessage.name);
      const auth = getFileOperateAuthority(
        "onlinePreview",
        currentFileControl || [],
        fileMessage?.fileTag || 0
      );
      const canEdit = getFileOperateAuthority(
        "tranferTo",
        currentFileControl || [],
        message?.fileTag || 0
      );
      console.log("fileMesa=>", fileMessage);
      // const toUser = parseMessageToUserBySingle(selectedSession.sessionId, {
      //   ...message.from,
      //   userId: message.from.pin
      // } as any);
      // console.log(toUser);
      if (!auth && isWpsFile) {
        toast.info(t("file-secret-tip"));
        return;
      }
      if (!isEgovFile && isWpsFile) {
        const isExpired = checkFileIsExpired({
          expiredAppKey: imAppKey,
          message: fileMessage,
          updateSessionMessageMid,
          expiredTime: im.fileExpiredTime
        });
        if (isExpired) return;
        let previewParams: any = {
          url: fileMessage.url,
          mid: fileMessage.mid,
          groupId: selectedSession.isGroup ? selectedSession.sessionId : undefined
        };
        previewParams = {
          ...previewParams,
          id: fileMessage.id,
          fileName: fileMessage.name,
          from: {
            pin: fileMessage.from.pin,
            app: fileMessage.from.app,
            teamId: fileMessage.from.teamId
          }
        };
        if (selectedSession.isSingle) {
          const toUser = parseMessageToUserBySingle(selectedSession.sessionId, {
            ...fileMessage.from,
            userId: fileMessage.from.pin
          } as any);
          console.log(toUser);
          previewParams.to = toUser;
        }
        getWpsPreviewCode(previewParams).then((res) => {
          if (res[0]) {
            const { joyspaceHost } = appRuntimeEnv;
            handleAddFileDownloadRecord(fileMessage, currentEmployee, 1, selectedSession);
            openJoyspacePreview({
              host: joyspaceHost,
              code: res[0].code,
              isShowHeader: 1,
              canSaveToJoyspace: canEdit,
              gid: selectedSession.isGroup ? selectedSession.sessionId : undefined,
              gname: selectedSession.isGroup ? selectedSession.info.name : "",
              canEdit: canEdit && getPreviewCanEdit(previewParams.fileName),
              canForward: 1
            });
          } else {
            handleDownload(fileMessage);
          }
        });
        return;
      } else {
        handleDownload(fileMessage);
      }
    } else {
      handleDownload(fileMessage);
    }
  };

  const getHead = () => {
    if (isModalVisible) {
      const forwardMessage = replyMsg as any;
      let realName = forwardMessage.nickName || forwardMessage.realname;
      if (forwardMessage.data[0]?.title?.mergeKind === "group") {
        let fromGroupName = forwardMessage.data[0]?.title?.fromGroupName;
        if (fromGroupName) {
          return <div className="head">{t("more_communicate_record", { fromGroupName })}</div>;
        } else {
          return <div className="head">{t("group_communicate_record")}</div>;
        }
      }
      if (realName !== forwardMessage.data[0]?.title?.toRealname) {
        return (
          <div className="head">
            {t("double_communicate_record", {
              realName,
              toRealname: forwardMessage.data[0]?.title?.toRealname
            })}
          </div>
        );
      } else {
        return <div className="head">{t("single_communicate_record", { realName })}</div>;
      }
    }
  };

  const forwardMessage = async (message: any) => {
    if (flag) {
      return;
    }
    flag = true;
    const imService = ImService.getInstance();
    const result: any = await imService.getMergeForwardBody(
      changeEgovUrl(message.data[0]?.content),
      message.id
    );
    if (result?.messages) {
      setModalMessages(result.messages);
      let timeSection = "";
      if (result.messages.length === 1) {
        timeSection = TimeTransform(result.messages[0].timestamp);
      } else {
        let start = TimeTransform(result.messages[0].timestamp);
        let end = TimeTransform(result.messages[result.messages.length - 1].timestamp);
        if (start !== end) {
          timeSection = start + " ~ " + end;
        } else {
          timeSection = start;
        }
      }
      setTimeSection(timeSection);
      setIsModalVisible(true);
      // count++;
    } else {
      setIsModalVisible(false);
    }
    const nodes = document.querySelectorAll(".ant-modal-mask:not(.ant-modal-mask-hidden)");
    if (nodes && nodes.length > 0) {
      nodes.forEach((node, index) => {
        if (index === 0) {
          (node as HTMLElement).style.backgroundColor = "rgba(0, 0, 0, 0.45)";
        } else {
          (node as HTMLElement).style.backgroundColor = "inherit";
        }
      });
    }
    setTimeout(() => {
      flag = false;
    }, 500);
  };

  const handleClickCard = (shareMessage: any) => {
    const version = getAppVersion(FocusSDK);
    const { common_card = {} } = shareMessage.data[0] || {};
    if (!common_card.pcUrl) {
      return;
    }
    const parseUrl = DeeplinkEvent.parseDeeplink(common_card.pcUrl);
    if (!parseUrl) {
      toast.warn("当前跳转链接不符合规范");
      return;
    }
    const isPrivateNet = FocusSDK.isPrivateNet();
    const mparam = parseUrl.mparam || {};
    if (isFocusEnv() && version < (mparam.minVersion || "1.0.0")) {
      toast.warn("当前版本暂不支持，请升级至最新版本");
      return;
    }
    let realUrl = isPrivateNet ? mparam.egovUrl : mparam.url;
    if (!realUrl) {
      toast.warn("该应用不支持在当前网络环境下打开");
      return;
    }
    realUrl = genThirdAppUrl(
      common_card.applicationKey,
      authInfo.ddAppId,
      authInfo.accessToken,
      appRuntimeEnv,
      {
        redirectUrl: realUrl
      }
    );
    console.log("点击引用消息", realUrl);
    window.open(realUrl);
  };

  const getReplyCardContent = () => {
    const shareMessage = replyMsg as JoySpaceDocumentMessage;
    const sharelink =
      shareMessage.data && shareMessage.data[0]
        ? shareMessage.data[0].sharelink
        : { category: "", url: "" };
    const { template } = shareMessage;
    if (template.nativeId === "merge_forward") {
      forwardMessage(shareMessage);
      return;
    }
    if (template.nativeId === "share_link") {
      if (sharelink?.category === "jd_doc") {
        if (sharelink?.url && sharelink.url.indexOf("http") > -1) {
          window.open(sharelink.url);
        }
        return;
      } else {
        openShareCommonCard(shareMessage);
        return;
      }
    } else if (template.nativeId === "share_card") {
      openShareUserCard(shareMessage);
      return;
    } else if (template.nativeId === "common_card") {
      handleClickCard(shareMessage);
    } else if (isOrgNoticeImageTextCardMessage(shareMessage)) {
      const dataInfo = getOrgNoticeMultiMessageData(shareMessage);
      if (dataInfo?.url) {
        const parseUrl = DeeplinkEvent.parseDeeplink(dataInfo?.url);
        if (parseUrl.pathname && parseUrl.pathname.includes("browser")) {
          const mparam = parseUrl.mparam || {};
          let realUrl = mparam.url;
          if (realUrl) {
            window.open(realUrl);
            return;
          }
        }
      }
      return;
    } else {
      console.log("不支持");
      return;
    }
  };

  const getReplyJoyspaceFileContent = () => {
    const joyspaceFileMessage = replyMsg as JoySpaceDocumentMessage;
    const { data } = joyspaceFileMessage;
    let webUrl = "";
    // @ts-ignore
    // 兼容移动端的神奇代码
    if (data?.[0]?.joySpaceLinkDetail) {
      // @ts-ignore
      const joySpaceLinkDetail = data[0].joySpaceLinkDetail || {};
      webUrl = joySpaceLinkDetail.webUrl;
    }
    webUrl = joyspaceFileMessage.webUrl;
    window.open(webUrl);
  };
  const history = useHistory();
  const getReplyJoyspaceFolderContent = () => {
    history.push(`/joyspace/teamspace?categoryId=${replyMsg?.fileId}`);
  };
  // 组通知引用
  const getReplyGroupNotice = () => {
    const GroupNoticeMessage: any = replyMsg as ChatMessage;
    if (!GroupNoticeMessage) return;
    openNoticeDetails({
      isvisibles: true,
      notificationId: GroupNoticeMessage.notificationId
    });
  };
  // 组接龙引用
  const getReplySolitaire = () => {
    const SolitaireMessage: any = replyMsg as ChatMessage;
    if (!SolitaireMessage) return;
    openSolitaireDetails({
      isvisibles: true,
      solitaire: SolitaireMessage.solitaireId
    });
  };

  // 位置
  const getReplyLocation = () => {
    // console.log("lyj---引用点击位置消息", replyMsg);
    window.open((replyMsg as any).url);
  };

  function viewReplyMessage(e: any) {
    // 引用内容撤销不可点击
    if (replyMsg?.revoke || isModalVisible) {
      return;
    }
    e.preventDefault();
    e.stopPropagation();
    // logger.debug('replyMsgContent =====>>', replyMsg);
    switch (replyMsg?.type) {
      case ChatMessageType.TEXT:
        getReplyTextContent();
        break;
      case ChatMessageType.IMAGE:
        getReplyImageContent();
        break;
      case ChatMessageType.VIDEO:
        getReplyVideoContent();
        break;
      case ChatMessageType.VOICE:
        // 音频内容不可被引用
        console.log("voice");
        break;
      case ChatMessageType.FILE:
        getReplyFileContent();
        break;
      case ChatMessageType.EGOV_FILE:
        getReplyFileContent();
        break;
      case ChatMessageType.JOYSPACEFILE:
        getReplyJoyspaceFileContent();
        break;
      case ChatMessageType.JOYSPACEFOLDER:
        getReplyJoyspaceFolderContent();
        break;
      case ChatMessageType.TEMPLATE2:
        getReplyCardContent();
        break;
      case ChatMessageType.GROUPNOTICE:
        getReplyGroupNotice();
        break;
      case ChatMessageType.SOLITAIRE:
        getReplySolitaire();
        break;
      case ChatMessageType.LOCATION_JD:
        getReplyLocation();
        break;
      default:
        console.log("default chatmessage");
        break;
    }
  }
  const visibleChange = (e: MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    bus.emit("message-item-chatitem", false);
  };

  useEffect(() => {
    if (isModalVisible) {
      document.addEventListener("contextmenu", visibleChange);
      return () => {
        document.removeEventListener("contextmenu", visibleChange);
      };
    }
  }, [isModalVisible]);
  if (replyMsg?.type) {
    return (
      <Popover
        visible={visible}
        destroyTooltipOnHide
        trigger="click"
        overlayClassName="reply-message-text-popover"
        placement={
          sendType === MessageSendType.SELF || sendType === MessageSendType.OWNER ? "left" : "right"
        }
        // placement="left"
        onVisibleChange={onVisibleChange}
        content={
          <Text
            message={replyMsg}
            sessionType={selectedSession.sessionType}
            sendType={getMessageSendType(replyMsg, currentEmployee, selectedSession)}
            noPreAndNext={true}
          />
        }
      >
        <div className="reply-message" onClick={debounce(viewReplyMessage, 500)} ref={dRef}>
          <div className="reply-message-line" />
          <div className="reply-message-content">
            {replyMsg.revoke ? (
              <div className="revoke-tips">{t("revoke content")}</div>
            ) : (
              <>
                <div className="revoke-tips">
                  <div className="ellipsis">{`${t("quote")} ${
                    replyMsg.sender.nickName || replyMsg.sender.name
                  }`}</div>
                  <ComGroupAlias user={replyMsg.sender} session={selectedSession} />
                </div>
                ：{/* {getReplyMessageDesc(replyMsg)} */}
                <p
                  style={{ overflow: "hidden", textOverflow: "ellipsis" }}
                  className="reply-message-desc"
                  dangerouslySetInnerHTML={{
                    __html: getReplyMessageDesc(replyMsg, selectedSession)
                  }}
                />
              </>
            )}
          </div>
          <Modal
            title={getHead()}
            visible={isModalVisible}
            destroyOnClose={true}
            footer={null}
            width={550}
            zIndex={100}
            centered
            className="forwardModal"
            onCancel={(e: any) => {
              e.stopPropagation();
              // count--;
              flag = false;
              setTimeSection("");
              setModalMessages([]);
              setIsModalVisible(false);
            }}
          >
            <div className="title">{timeSection}</div>
            <div className="forward-lists">
              {modalMessages.map((message: any, index: number) => {
                return (
                  <div key={index} className="wrapper">
                    <div className="forward-list">
                      <div className="left">{getHeadPortrait(message)}</div>
                      <div className="right">
                        <div className="name">
                          <div>{message.senderName || message.realname}</div>
                          <div>{getShowTime(message)}</div>
                        </div>

                        <div className="message-box">
                          <div className="content-row">
                            <div className="content-col">
                              {getChatMessageNode(modalMessages, message, true, replyMsg)}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="line" />
                  </div>
                );
              })}
            </div>
          </Modal>
        </div>
      </Popover>
    );
  }
  return null;
}

function mapStateToProps({ chat }: any) {
  const { currentEmployee, selectedSession } = chat;

  return { currentEmployee, selectedSession };
}

function mapDispatchToProps(dispatch: any) {
  return {
    openNoticeDetails(data: { isvisibles: boolean; notificationId: any }) {
      dispatch({ type: "chat/openNoticeDetails", payload: data });
    },
    openSolitaireDetails(data: { isvisibles: boolean; solitaire: any }) {
      dispatch({ type: "chat/openSolitaireDetails", payload: data });
    },
    updateSessionMessageMid(data: { message: ChatMessage; sessionId: String }) {
      dispatch({ type: "chat/updateSessionMessageMid", payload: data });
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ReplyMessage);
